import { ActionReducerMap, createSelector, createFeatureSelector, ActionReducer, MetaReducer } from '@ngrx/store';
import { environment } from '../environments/environment';
import { RouterStateUrl } from './core/utils/router.utils';

/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
import { storeFreeze } from 'ngrx-store-freeze';


/* import reducer files
------------------------------------------------------------ */
import * as LayoutReducer from './core/reducers/layout';
import * as RouterReducer from '@ngrx/router-store';




/* AppState
------------------------------------------------------------ */
export interface AppState {
  layout:LayoutReducer.State;
  routerReducer:RouterReducer.RouterReducerState<RouterStateUrl>;
}


/* reducers map
------------------------------------------------------------ */
export const reducers:ActionReducerMap<AppState> = {
  layout: LayoutReducer.reducer,
  routerReducer: RouterReducer.routerReducer,
};



/* metaReducers
------------------------------------------------------------ */
// By default, @ngrx/store uses combineReducers with the reducer map to compose
// the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
// that will be composed to form the root meta-reducer.
export const metaReducers:MetaReducer<AppState>[] = !environment.production
  ? [logger, storeFreeze]
  : [];


// console.log all actions
export function logger(reducer:ActionReducer<AppState>):ActionReducer<AppState> {
  return function (state:AppState, action:any):AppState {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}




























/* slice reducers
------------------------------------------------------------------------------------------ */


export const getLayoutState = createFeatureSelector<LayoutReducer.State>('layout');
export const getShowSidenav = createSelector(getLayoutState, LayoutReducer.getShowSidenav);



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/reducers.ts